import { Component, OnInit, EventEmitter,Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { NOTES } from 'src/app/models/um/organization';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Document_Upload_File } from 'src/app/models/common';
import { serviceConstants } from 'src/app/constants/service.constants';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-notes-view-modal',
  templateUrl: './notes-view-modal.component.html',
  styleUrls: ['./notes-view-modal.component.scss']
})
export class NotesViewModalComponent implements OnInit {
  @Input() public Content: any
  formFields = new UntypedFormGroup({
   ID: new UntypedFormControl(""),
   APPLICATION_ID: new UntypedFormControl(""),
   NOTES1: new UntypedFormControl(""),
 })

  notesForm = new UntypedFormGroup({
    NOTES1: new UntypedFormControl(null)
  })

  content: any;
  heading: string;
  action: Subject<any> = new Subject();

  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  note: NOTES;
  document_attach_list: Document_Upload_File[] = [];
  permission: string = "";

  constructor(
    public modalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService,
    private modalService: NgbModal

  ) {

  }

  ngOnInit() {
    this.permission = "";
    var lper = this.commonService.getPagePermission("IST17");
    if (lper != null && lper) {
       ;
      this.permission = lper.toLowerCase();
    }

    if (this.Content.content && this.Content.content.id) { // Edit mode
      this.summaryService.getRFIByID('api/rfi/getrfibyid/' + this.Content.content.id).subscribe((result) => {
        this.setForm(result);
        if (this.Content.heading === 'View') {
          setTimeout(() => {
            //this.deptForm.disable({ emitEvent: false });
          }, 100);
        }
      });
    }
    else {
      this.note = new NOTES();
      this.note.APPLICATION_ID = this.Content.content.appid;
      this.note.MODULE_ID = this.commonService.getModuleId(this.Content.content.module);
      this.setForm(this.note);
    }

   
  }

  setForm(result: NOTES): void {
    this.formFields = new UntypedFormGroup({
      ID: new UntypedFormControl(result.ID),
      APPLICATION_ID: new UntypedFormControl(result.APPLICATION_ID),
      NOTES1: new UntypedFormControl(result.NOTES1),
      MODULE_ID: new UntypedFormControl(result.MODULE_ID),
    });

    if (this.permission == "view") {
      this.formFields.disable();
    }
  }

  private getForm(): NOTES {

    const formModel = this.formFields.value;

    let notes = new NOTES();
    notes = {
      ID: formModel.ID || '',
      APPLICATION_ID: formModel.APPLICATION_ID || '',
      NOTES1: formModel.NOTES1 || '',
      MODULE_ID: formModel.MODULE_ID || ''
    };

    return notes;
  }

  save() {
    if (this.validateControls()) {

      let formData1 = new FormData();
      if (this.document_attach_list !== null && this.document_attach_list.length > 0) {
        for (let i = 0; i < this.document_attach_list.length; i++) {
          this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
          formData1.append(("" + (i + 1)), this.document_attach_list[i].File);
        }
      }
      formData1.append("ScreenData", JSON.stringify(this.getForm()));

      if (this.Content.content && this.Content.heading === 'Add') {
        this.summaryService.InsertWithFiles('api/notes/insertnote', formData1).subscribe(result => {
          if (result.Status === 0) {
            this.commonService.SuccessBanner('Notes added successfully');
            
            this.modalRef.close();
          }
          else {
            this.commonService.ValidationBanner(result.Message);
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: result.Message } } });
          }
        })

      } else if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit') {
        this.summaryService.Insert('api/notes/update', this.getForm()).subscribe(result => {
          if (result.Status === 0) {
            this.commonService.SuccessBanner("Data has been Updated successfully");
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Data has been Updated successfully' } } });
            
            this.modalRef.close();
          }
          else {
            this.commonService.ValidationBanner(result.Message);
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: result.Message } } });
          }
        })
      }
    }
    }

  showFiles() {
    let files = '';
    if(this.files && this.files.length >0){
      for (let i = 0; i < this.files.length; i++) {
        files += this.files[i].name;
        if (!(this.files.length - 1 === i)) {
          files += ',';
        }
      }
    }
    return files;
  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.formFields.value;

    if (formData.NOTES1 === null || formData.NOTES1 === "" || formData.NOTES1 === undefined) {
      $("#NOTES1").addClass("ng-touched ng-invalid validate-error");
      $("#NOTES1").removeClass("ng-untouched ng-valid");
      message += "Please enter Notes<br/>";
      isValid = false;
    } else {
      $("#NOTES1").addClass("ng-untouched ng-valid");
      $("#NOTES1").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
    this.commonService.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }


 
  uploadchange(event): void {
    if (this.document_attach_list == undefined || this.document_attach_list == null) {
      this.document_attach_list = [];
    }
    let hasUnFormat = false;
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;   
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext !='docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) 
      {
        hasUnFormat = true; 
      }
      else 
      {
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        let hasValue = this.document_attach_list.filter(x=> x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        if(hasValue.length > 0)
        {
          this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
        } else
        {
          this.document_attach_list.push(uploadFile);
        }
      }
    }
    if (hasUnFormat) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
    }
  }

  downloadFile(ID) {
    let url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + ID;
    window.open(url);
  }

  DeleteUpload(file): void {
    let code = file.ID;
    this.document_attach_list = this.document_attach_list.filter(function (sec) {
      return sec.ID != code;
    }, code);
  }

  
}
